module.exports = __webpack_public_path__ + "img/login-bg.08202843.png";